import { LitElement, customElement, html, property } from 'lit-element';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */
/**
 * Loading spinner for adding and deleting items
 */
@customElement('custom-spinner')
class CustomSpinnerComponent extends LitElement {
  /* eslint-disable camelcase */
  @property({ type: Number })
  size = 100;

  @property({ type: Number })
  duration = 1.5;

  @property({ type: String })
  circle_color = 'rgba(255,255,255, 0.3)';

  @property({ type: String })
  loader_color = 'white';

  @property({ type: Number })
  circle_width = 7;

  connectedCallback() {
    if (!process.env.IS_TEST) {
      super.connectedCallback();
    }

    if (Number.isNaN(+this.size)) {
      throw new Error('`size` prop must be a number in `custom-spinner` component.');
    }

    if (Number.isNaN(+this.duration)) {
      throw new Error('`duration` prop must be a number in `custom-spinner` component.');
    }

    if (!this.circle_color || typeof this.circle_color !== 'string') {
      throw new Error('`circle_color` must be a non-empty `string` in `custom-spinner` component.');
    }

    if (!this.loader_color || typeof this.loader_color !== 'string') {
      throw new Error('`loader_color` must be a non-empty `string` in `custom-spinner` component.');
    }

    if (Number.isNaN(+this.circle_width)) {
      throw new Error('`circle_width` prop must be a number in `custom-spinner` component.');
    }
  }

  render() {
    const size = `${+this.size}px`;
    const animation = `custom-loader ${this.duration}s linear infinite`;
    const circleWidth = `${this.circle_width}px`;
    const loaderColor = `${this.loader_color} !important`;

    return html`
      <style>
        .loader {
          text-align: -webkit-center;
        }

        .loader:before {
          display: block;
          content: '';
          width: ${size};
          height: ${size};
          border-radius: 50%;
          border-style: solid;
          border-width: ${circleWidth};
          border-color: ${this.circle_color};
          border-bottom-color: ${loaderColor};
          animation: ${animation};
          right: 0;
          top: 0;
          z-index: 10;
          margin: 0;
        }

        @keyframes custom-loader {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      </style>
      <div class="loader"></div>
    `;
  }
}

export default CustomSpinnerComponent;
